import { useEffect, useState } from "react";
import { IPagination } from "../../../types/pagination";
import { IEventoDTO, IEventosProps } from "../../../types/agendamento";
import { useMediaQuery } from "react-responsive";
import { useSearchParams } from "react-router-dom";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { HistoricoAgendamento } from "../../../services/HistoricoAgendamento";
import { IHistoricoAgendamentoDTO } from "../../../types/historicoAgendamento";

export const useHistoryModifySchedule = () => {
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [numberPage, setNumberPage] = useState(0);
  const [events, setEvents] = useState<IHistoricoAgendamentoDTO[]>([]);
  const isMobile = useMediaQuery({ maxWidth: "640px" });
  const { setIsLoad } = useContextSite();
  const [searchParams, setSearchParams] = useSearchParams();
  let uuidAgendamento = searchParams.get("id");

  function getEvents(props: IEventosProps) {
    setIsLoad(true);
    HistoricoAgendamento.listar({ ...props, size: 5 })
      .then(({ data }) => {
        setEvents(data.content);
        setPagination({
          actualPage: data.number,
          totalPage: data.totalPages,
          totalRegister: data.totalElements,
        });
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    if (uuidAgendamento) {
      getEvents({
        uuidAgendamento,
        page: numberPage,
      });
    }
  }, [numberPage, uuidAgendamento]);

  return { pagination, setNumberPage, events, isMobile };
};
